import React from "react";
import PropTypes from "prop-types";
import { StyledButton } from "./IconButton.styles";
const IconButton = ({ icon, onClick, ...props }) => {
    return (
        <StyledButton
            className={props.className}
            onClick={(event) => onClick(event)}
            {...props}
        >
            {icon}
        </StyledButton>
    );
};

IconButton.propTypes = {
    icon: PropTypes.node,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

export default IconButton;
